const errors = {
  "api.error.payment.promo-code.invalid": "Invalid promo code",
  "api.error.payment.promo-code.inactive": "This promo code is not active",
  "api.error.payment.promo-code.first-time-only": "This promo code can only be used once",
  "api.error.payment.promo-code.already-used": "You have already used this discount, and it cannot be applied again",
};

export const api = {
  ...errors,
};
